<template>
  <div class="container mt-5 text-center justify-content-center">
    <div class="row justify-content-center">
      <p class="fw-bold fs-5 text-dark mb-5">
        Contact me using my phone number or email :)
      </p>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 ml-auto text-center mb-5 mb-lg-0">
        <i class="fas fa-phone fa-3x mb-3"></i>
        <div>(+63) 9213524392</div>
      </div>
      <div class="col-lg-4 mr-auto text-center">
        <i class="fas fa-envelope fa-3x mb-3"></i>
        <!-- Make sure to change the email address in BOTH the anchor text and the link target below!-->
        <a class="d-block" href="201801106@iacademy.edu.ph"
          >201801106@iacademy.edu.ph</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact-body",
};
</script>

<style>
</style>